import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Truck, RefreshCw, Clock, Zap, AlertCircle } from 'lucide-react';
import { usePricing } from '../hooks/usePricing';
export function ProductOffer() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const {
    formattedPrice,
    formattedOriginalPrice,
    isLoading
  } = usePricing();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const [viewers, setViewers] = useState(24);
  const [spotsLeft, setSpotsLeft] = useState(47);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return Math.min(Math.max(next, 18), 32);
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 3) return prev;
        return Math.random() > 0.7 ? prev - 1 : prev;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  return <section id="producto" className="py-10 md:py-16 bg-chocolate text-white" data-id="element-241">
      <div className="max-w-4xl mx-auto px-4" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-243">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-terracotta/20 border border-terracotta/30 rounded-full mb-5 animate-pulse" data-id="element-244">
            <Clock size={14} className="text-terracotta" data-id="element-245" />
            <span className="text-sm font-bold text-terracotta" data-id="element-246">
              Oferta termina en {formatTime(timeLeft)}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-3" data-id="element-247">
            No dejes pasar esta <span className="text-copper" data-id="element-248">oportunidad</span>
          </h2>
          <p className="text-white/60 max-w-lg mx-auto" data-id="element-249">
            Accede a la colección completa con todos los bonos incluidos. Esta
            oferta no estará disponible para siempre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-250">
          <img src="https://cdn.magicpatterns.com/uploads/8VPmE57bCjoWcdR4zzicK2/20260225_1731_Image_Generation_simple_compose_01kjb7zbkpetat25nqp9xr0xsh_(1).png" alt="Colección completa: +60 Patrones Amigurumis de Mascotas con todos los bonos" className="w-full rounded-xl shadow-2xl" data-id="element-251" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-6 md:p-10 text-deep-brown max-w-2xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-252">
          <div className="absolute top-0 right-0 bg-terracotta text-white font-bold px-4 py-2 rounded-bl-xl shadow-md z-10" data-id="element-253">
            70% OFF
          </div>

          <div className="flex flex-col gap-3 mb-6 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-254">
            <div className="flex items-center gap-2 text-red-600 text-sm font-medium" data-id="element-255">
              <span className="relative flex h-3 w-3" data-id="element-256">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-257"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-258"></span>
              </span>
              {viewers} personas están viendo esta página
            </div>
            <div className="flex items-center gap-2 text-terracotta text-sm font-bold" data-id="element-259">
              <AlertCircle size={16} data-id="element-260" />
              Solo {spotsLeft} cupos con descuento restantes
            </div>
          </div>

          <h3 className="text-2xl font-heading font-bold text-deep-brown mb-2 text-center" data-id="element-261">
            Colección Completa + 4 Bonos
          </h3>
          <p className="text-gray-500 text-sm text-center mb-6" data-id="element-262">
            +60 patrones por raza · Guía de personalización · 4 bonos exclusivos
            · Acceso de por vida
          </p>

          <div className="text-center mb-8" data-id="element-263">
            <div className="flex items-center justify-center gap-3" data-id="element-264">
              <span className="text-gray-400 line-through text-xl" data-id="element-265">
                {isLoading ? '...' : formattedOriginalPrice}
              </span>
              <span className="text-4xl md:text-5xl font-bold text-terracotta" data-id="element-266">
                {isLoading ? '...' : formattedPrice}
              </span>
            </div>
            <p className="text-sm text-copper font-medium mt-1" data-id="element-267">
              *Precio especial solo por hoy
            </p>
          </div>

          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse w-full py-4 bg-copper text-white rounded-full font-bold text-lg shadow-lg hover:shadow-xl hover:bg-copper/90 transition-all duration-300 block text-center mb-6" data-id="element-268">
            Quiero Mi Ebook Ahora →
          </a>

          <div className="flex flex-wrap justify-center gap-5 text-xs text-gray-400 mb-6" data-id="element-269">
            <span className="flex items-center gap-1.5" data-id="element-270">
              <Lock size={13} data-id="element-271" /> Pago 100% Seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-272">
              <Truck size={13} data-id="element-273" /> Entrega Inmediata
            </span>
            <span className="flex items-center gap-1.5" data-id="element-274">
              <Shield size={13} data-id="element-275" /> Garantía 7 días
            </span>
          </div>

          {/* Payment Methods Image — full width */}
          <div className="border-t border-gray-100 pt-5 mb-5" data-id="element-276">
            <img src="https://cdn.magicpatterns.com/uploads/3FFZE6SX62bsFCMuZtkyxF/20260209_1407_Image_Generation_remix_01kh1nwysjfqcvry1q12n9m1jf_(1).png" alt="Pago seguro garantizado: Visa, Mastercard, Maestro, PayPal" className="w-full max-w-md mx-auto" data-id="element-277" />
          </div>

          <div className="bg-linen rounded-xl p-4 flex items-start gap-3" data-id="element-278">
            <RefreshCw size={20} className="text-teal flex-shrink-0 mt-0.5" data-id="element-279" />
            <div data-id="element-280">
              <p className="font-bold text-deep-brown text-sm mb-1" data-id="element-281">
                Garantía de satisfacción de 7 días
              </p>
              <p className="text-gray-500 text-xs leading-relaxed" data-id="element-282">
                Si el ebook no cumple tus expectativas, te devolvemos tu dinero
                completo. Sin preguntas, sin complicaciones.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}